module.exports = __webpack_public_path__ + "assets/img/btn-view-pedigree-chart-f7f25ac5.png";